import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCtAutomatedStrategy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M10.915 11.516a.75.75 0 1 0-1.06-1.06L8.048 12.26a.75.75 0 1 0 1.061 1.06l1.805-1.805ZM13.562 14.163a.75.75 0 0 0-1.06-1.06l-1.806 1.804a.75.75 0 0 0 1.061 1.061l1.805-1.805Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M21.984 2.274a.75.75 0 0 1 0 1.061l-1.329 1.329a5.674 5.674 0 0 1-.605 7.308l-1.934 1.934a.75.75 0 0 1-1.06 0l-6.961-6.961a.75.75 0 0 1 0-1.061l1.933-1.934a5.673 5.673 0 0 1 7.6-.381l1.295-1.295a.75.75 0 0 1 1.06 0Zm-8.882 2.724-.013.013-1.403 1.403 5.9 5.9 1.403-1.403a4.172 4.172 0 0 0-5.887-5.913ZM11.972 20.05l1.933-1.934a.75.75 0 0 0 0-1.06l-6.96-6.961a.75.75 0 0 0-1.061 0L3.95 12.028l-.015.016a5.674 5.674 0 0 0-.59 7.293l-1.329 1.328a.75.75 0 0 0 1.061 1.06l1.294-1.294a5.673 5.673 0 0 0 7.6-.381Zm-1.074-1.048a4.172 4.172 0 0 1-5.887-5.913l1.403-1.403 5.9 5.9-1.403 1.403-.013.013Z"
    />
  </svg>
);
export default SvgTwoColorCtAutomatedStrategy;
